import {stringify} from 'qs'
import {format} from 'utils'
import api from 'app-self-support-order/common/api/order-import'
import request from 'app-self-support-order/utils/request'

// 获取订单
export async function getOrderList(params = {}) {
    return request(`${api.getOrderList.url}?${stringify(params)}`)
}

// 获取导入失败订单
export async function getFailedOrderlist(params) {
    return request(format(`${api.getFailedOrderlist.url}?${stringify(params)}`, {id: params.id}))
}

// 修改备注
export async function editRemark(payload) {
    return request(format(`${api.editRemark.url}`, {id: payload.id}), {
        method: api.editRemark.type,
        body: payload.body,
    })
}

// 手动导入订单
export async function importOrderByManual(payload) {
    return request(api.importOrderByManual.url, {
        method: api.importOrderByManual.type,
        body: payload.body,
    })
}

// 获取API订单接入-设置
export async function getIpSetting() {
    return request(api.getIpSetting.url)
}

export async function resetIpSetting() {
    return request(api.resetIpSetting.url, {
        method: api.resetIpSetting.type,
    })
}

export async function setIpSetting(payload) {
    return request(api.setIpSetting.url, {
        method: api.setIpSetting.type,
        body: payload.body,
    })
}
